import type { WregStep } from '@/components/webreg/wregSteps';

const WREG_TITLE: Record<WregStep, string> = {
  intake: 'wreg.doc.intake',
  'intake-contact': 'wreg.doc.intake-contact',
  'intake-about': 'wreg.doc.intake-about',
  'intake-mbi': 'wreg.doc.intake-mbi',
  screener: 'wreg.doc.screener',
  tracks: 'wreg.doc.tracks',
  agreement: 'wreg.doc.agreement',
  switch: 'wreg.doc.switch',
  labs: 'wreg.doc.labs',
  monitor: 'wreg.doc.monitor',
  allset: 'wreg.doc.allset',
  'x-notelig': 'wreg.doc.x-notelig',
  'x-already': 'wreg.doc.x-already',
  'x-control': 'wreg.doc.x-control',
  'x-mismatch': 'wreg.doc.x-mismatch',
  'x-noqualify': 'wreg.doc.x-noqualify',
  'x-error': 'wreg.doc.x-error',
  'x-switchok': 'wreg.doc.x-switchok',
  'x-outreach': 'wreg.doc.x-outreach',
  'x-labspending': 'wreg.doc.x-labspending',
  'x-declined': 'wreg.doc.x-declined',
};

export const WREG_DOC_BRAND = 'Happy Hearts';

export const wregTitleKey = (step: WregStep): string => WREG_TITLE[step];

export const wregDocTitle = (label: string): string => `${label} - ${WREG_DOC_BRAND}`;
